import { render, staticRenderFns } from "./DuplicateMediaCallBtn.vue?vue&type=template&id=192b84ff&"
import script from "./DuplicateMediaCallBtn.vue?vue&type=script&lang=js&"
export * from "./DuplicateMediaCallBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192b84ff')) {
      api.createRecord('192b84ff', component.options)
    } else {
      api.reload('192b84ff', component.options)
    }
    module.hot.accept("./DuplicateMediaCallBtn.vue?vue&type=template&id=192b84ff&", function () {
      api.rerender('192b84ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/DuplicateMediaCallBtn.vue"
export default component.exports